import { SimpleDialog, FormField } from '../../../shared/components/index';
import { Box, Typography, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldType } from '../../../shared/components/form-field/service/formFieldInterface';
import {
  I18N,
  REGEX,
  TENANT_ROLES,
  ROLES
} from '../../../shared/constants/constants';
import { FormikProvider } from 'formik';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { selectUserState } from 'src/auth/login/services/userSlice';
const AddUserModal = ({
  isAddModal,
  open,
  onClose,
  onSubmit,
  handleClose,
  editObject
}) => {
  const [fields, setFields] = useState([] as FormFieldType[]);
  const { i18n, t } = useTranslation(I18N.DEFAULT);
  const { loginUserRole } = useSelector(selectUserState);
  const configurableRole =
    loginUserRole == ROLES.TENANT_OPERATOR
      ? [TENANT_ROLES[1], TENANT_ROLES[2]]
      : TENANT_ROLES;
  const initialFormikValue = {
    id: null,
    name: '',
    status: true,
    
  };
  const formik = useFormik({
    initialValues: initialFormikValue,
    validateOnMount: false,
    onSubmit: (values: any) => {
      onSubmit(values);
    }
  });
  const { isValid, handleSubmit, resetForm, setFieldValue } = formik;

  const nameCustomFormFields: FormFieldType[] = [
    {
      id: 'name',
      name: 'name',
      type: 'multi-text',
      label: t('name'),
      validations: {
        required: true,
        maxLength: 50
      },
      errorMessages: {
        requiredErrMsg: 'name is required'
      }
    }
  ];

  
  const statusCustomFormFields: FormFieldType[] = [
    {
      id: 'status',
      name: 'status',
      type: 'checkbox',
      label: 'status',
      validations: {
        required: true,
        maxLength: 50
      },
      errorMessages: {
        requiredErrMsg: 'status is required'
      }
    }
  ];

  useEffect(() => {
    if (isAddModal) {
      handleAddUserButtonClick();
    } else {
      handleEditIconClick(editObject);
    }
  }, [open]);
  const handleAddUserButtonClick = () => {
    const fields = [
       
      ...nameCustomFormFields,
      ...statusCustomFormFields
    ];
    setFields(fields);
    resetForm();
  };
  const handleEditIconClick = (row) => {
    const formFields = [ ];
    formFields.map((field) => {
      field.isDisabled = true;
      return field;
    });
    setFields([  ...nameCustomFormFields,
      ...statusCustomFormFields  ]);
    setFieldValue('name', row.name);
    setFieldValue('status', row.status);
    setFieldValue('id', row.id);
  };
  return (
    <>
      {' '}
      <SimpleDialog
        keepMounted
        fullWidth
        scroll="paper"
        model_title={
          <Typography sx={{ p: 3, pl: 2 }} variant="h4" fontWeight="bold">
            {isAddModal ? t('asset-type.add-asset-type') : t('edit-user')}
          </Typography>
        }
        model_content={
          <Box sx={{ pt: 1 }}>
            <FormikProvider value={formik}>
              {fields?.map((field, index) => (
                <Box key={'userFormFields' + index} className="mb-16">
                  <FormField fieldProps={field} />
                </Box>
              ))}
            </FormikProvider>
          </Box>
        }
        model_actions={
          <>
            <Box className="mb-15 mr-15">
              <Button
                size={'small'}
                className="letter-spacing mr-16"
                onClick={handleClose}
              >
                {t('action.cancel')}
              </Button>
              <Button
                size={'small'}
                className="letter-spacing"
                variant={'contained'}
                onClick={() => {
                  handleSubmit();
                }}
              >
                {t('action.submit')}
              </Button>
            </Box>
          </>
        }
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default AddUserModal;
